// // This file can be replaced during build by using the `fileReplacements` array.
// // `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// // The list of file replacements can be found in `angular.json`.
// import {IapticConfig, RegisterProduct} from '../app/services/in-app.service';

// export const inAppProducts = {
//   YEARLY_SUBSCRIPTION: 'shc_one_year_prod',
//   MONTHLY_SUBSCRIPTION: 'shc_one_month_prod',
//   CHAT_FEE_CONSUMABLE: 'shc_chat_fee_prod'
// };

// export const environment = {
//   production: true,
//   siteUrl: 'https://staging.swopster.appelit.dev',
//   apiUrl: 'https://staging.swopster.appelit.dev/api',
//   baseUrl: 'https://staging.swopster.appelit.dev/api',
//   // oneSignalId: '5bd84920-10a9-40ef-ad1c-9baba169b137',
//   oneSignalId: 'ae96f930-11ef-4570-beec-920badbde466', // From Staging env
//   // oneSignalId: 'd29f22d1-8db2-4995-bfa9-5f3bc5eebdd7', // From Production env
//   pusher: {
//     key: '7d769856dd5a35bc328e',
//     cluster: 'ap2',
//     // key: '1642f2cf43a372dd7618',  // related to ae96f930-11ef-4570-beec-920badbde466
//     // cluster: 'ap2',
//   },
//   fakeLocation: false,
//   fakeLocationData: {
//     coords: {
//       latitude: 52.37276,
//       longitude: 4.893604
//     }
//   },
//   inAppProductsConfig: {
//     products: [
//       {
//         id: inAppProducts.MONTHLY_SUBSCRIPTION,
//         type: 'PAID_SUBSCRIPTION',
//         group: 'premium_subscription',
//       } as RegisterProduct,
//       {
//         id: inAppProducts.YEARLY_SUBSCRIPTION,
//         type: 'PAID_SUBSCRIPTION',
//         group: 'premium_subscription',
//       } as RegisterProduct,
//       {
//         id: inAppProducts.CHAT_FEE_CONSUMABLE,
//         type: 'CONSUMABLE',
//       } as RegisterProduct
//     ],
//     validatorUrl: undefined,
//     iaptic: {
//       url: 'https://validator.iaptic.com',
//       // appName: 'com.appelit.shc.dev',
//       // apiKey: '5a1a9f39-c44c-40b4-8bdd-aa4b61c96152',
//       appName: 'com.swopsters.swopster.production',
//       apiKey: '1671ebe3-1c3b-4f13-971b-d51e8e2d2550',
//     } as IapticConfig,
//   }, admob: {
//     android: {
//       appopen: 'ca-app-pub-3940256099942544/3419835294',
//       banner: 'ca-app-pub-3940256099942544/6300978111',
//       interstitial: 'ca-app-pub-3940256099942544/1033173712',
//       nativeAd: 'ca-app-pub-3940256099942544/2247696110',
//     },
//     ios: {
//       appopen: 'ca-app-pub-3940256099942544/5662855259',
//       banner: 'ca-app-pub-3940256099942544/2934735716',
//       interstitial: 'ca-app-pub-3940256099942544/4411468910',
//       nativeAd: 'ca-app-pub-3940256099942544/3986624511',
//     }
//   }
// };

import {IapticConfig, RegisterProduct} from '../app/services/in-app.service';

export const inAppProducts = {
  YEARLY_SUBSCRIPTION: 'shc_one_year_prod',
  MONTHLY_SUBSCRIPTION: 'shc_one_month_prod',
  CHAT_FEE_CONSUMABLE: 'shc_chat_fee_prod'
};

export const environment = {
  production: false,
  // siteUrl: 'https://app.swopster.nl',
  // apiUrl: 'https://app.swopster.nl/api',
  // baseUrl: 'https://app.swopster.nl/api',
  // oneSignalId: 'd29f22d1-8db2-4995-bfa9-5f3bc5eebdd7',
  siteUrl: 'https://test.swopster.nl',
  apiUrl: 'https://test.swopster.nl/api',
  baseUrl: 'https://test.swopster.nl/api',
  oneSignalId: 'f6860582-0ec5-4903-84e7-62bd7c6ffcd9',
  appVersion: '1.6.6',
  pusher: {
    key: '7d769856dd5a35bc328e',
    cluster: 'ap2',
  },
  fakeLocation: false,
  fakeLocationData: {
    coords: {
      latitude: 52.37276,
      longitude: 4.893604
    }
  },
  inAppProductsConfig: {
    products: [
      {
        id: inAppProducts.MONTHLY_SUBSCRIPTION,
        type: 'PAID_SUBSCRIPTION',
        group: 'premium_subscription',
      } as RegisterProduct,
      {
        id: inAppProducts.YEARLY_SUBSCRIPTION,
        type: 'PAID_SUBSCRIPTION',
        group: 'premium_subscription',
      } as RegisterProduct,
      {
        id: inAppProducts.CHAT_FEE_CONSUMABLE,
        type: 'CONSUMABLE',
      } as RegisterProduct
    ],
    validatorUrl: undefined,
    iaptic: {
      url: 'https://validator.iaptic.com',
      appName: 'com.swopsters.swopster.production',
      apiKey: '1671ebe3-1c3b-4f13-971b-d51e8e2d2550',
    } as IapticConfig,
  },
  admob: {
    android: {
      appopen: 'ca-app-pub-3940256099942544/3419835294',
      banner: 'ca-app-pub-3940256099942544/6300978111',
      interstitial: 'ca-app-pub-3856536249911552/6036141728',
      nativeAd: 'ca-app-pub-3940256099942544/2247696110',
    },
    ios: {
      appopen: 'ca-app-pub-3940256099942544/5662855259',
      banner: 'ca-app-pub-3940256099942544/2934735716',
      interstitial: 'ca-app-pub-3856536249911552/5652998343',
      nativeAd: 'ca-app-pub-3940256099942544/3986624511',
    }
  }
};
